<template>
  <div id="l-wrapper" class="min-h-screen flex flex-col overflow-hidden">
    <slot />
  </div>
</template>

<style></style>
